import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  AppFacade,
  OfflineFacade,
  UserDetailsFacade,
} from '@shared/state/facades';
import { map, filter, Observable, take, tap } from 'rxjs';

@UntilDestroy()
@Injectable()
export class CacheService {
  constructor(
    private appFacade: AppFacade,
    private userDetailsFacade: UserDetailsFacade,
    private offlineFacade: OfflineFacade
  ) {}

  cleanCache(): void {
    this.appFacade.clearAppState();
    this.userDetailsFacade.setUserSession(null);
    this.offlineFacade.setBackupAuthenticationResult(null);

    this.offlineFacade.query.dprDetailsOfflineChanges$
      .pipe(
        untilDestroyed(this),
        take(1),
        filter(
          (dprDetailsOfflineChanges) => !(dprDetailsOfflineChanges || []).length
        ),
        tap(() => {
          this.offlineFacade.clearDprDetails();
        })
      )
      .subscribe();
  }

  /**
   * @description Checks to see if there are any changes saved.
   * If accountId is specified then check if there are any changes made by the specified user.
   */
  anyDprDetailsOfflineChanges(accountId?: string): Observable<boolean> {
    return this.offlineFacade.query.dprDetailsOfflineChanges$.pipe(
      map((dprDetailsOfflineChanges) => {
        if (!dprDetailsOfflineChanges) {
          return false;
        }

        if (!!accountId) {
          return (
            dprDetailsOfflineChanges.length > 0 &&
            dprDetailsOfflineChanges.some((x) => x.accountId === accountId)
          );
        } else {
          return dprDetailsOfflineChanges.length > 0;
        }
      })
    );
  }
}
